import {
  STAGE_GATE_3_ACTION_LABEL,
  WIRCreateJourneyStepsKeys,
  WIRStageGate3SectionKey,
  WIRStageGate3Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR, WIRActionStatus } from 'types/wellGuardian';
import { formatActionText } from './formatActionText';

const DEFAULT_STAGE_GATE_3_SECTION_KEYS: WIRStageGate3SectionKey[] = [
  'equipmentIdentification',
  'vendorEngagementSelection',
  'interventionStrategyDefined',
  'technicalReviewRiskReward',
  'technicalPosEstabilished',
  'afeCreated',
  'afeGhgEmission',
  // 'partnersNotified',
  // 'afeApproved',
  'wellInterventionOnPaper',
  'equipmentPreparation',
  // 'hqTechnicalReview',
  'programmeReview',
  'costSheetPrepared',
  'programmeDistributed',
  'reviewChecklistActions',
  'managerialSummary',
  'finalWirSignOff',
];

const CHECKLIST_STAGE_GATE_3_SECTION_KEYS: WIRStageGate3SectionKey[] = [
  'fpsWaiver',
  'bridgingSimopsDocuments',
  'vesselApplication',
  'wonsApplication',
  'hseNotification',
  'updateChemicalPermits',
  'sandingStudy',
  'perforationProforma',
  'chemicalChecksTopsideMetallurgy',
  'crossChemicalCompatibility',
  'chemicalChecksReservoir',
  'chemicalChecksFormation',
  'chemicalChecksTopsideEffluent',
  'chemicalChecksFlowBack',
  'cefasRegistration',
];

export const getWirStageGate3Sections = (wir: WIR | null) => {
  if (!wir) return [];

  const defaultSections = DEFAULT_STAGE_GATE_3_SECTION_KEYS
    .filter(item => item !== 'finalWirSignOff')
    .map(item => ({
      label: WIRStageGate3Sections[item],
      value: item,
      phase: WIRCreateJourneyStepsKeys.STAGE_GATE_3,
    }));

  const checklistSections = CHECKLIST_STAGE_GATE_3_SECTION_KEYS
    .filter(item => item !== 'finalWirSignOff')
    .map(item => ({
      label: WIRStageGate3Sections[item],
      value: item,
      phase: WIRCreateJourneyStepsKeys.STAGE_GATE_3,
    }))
    .filter(stepItem =>
      wir.actions?.some(
        action =>
          action.actionName === formatActionText(stepItem.label, STAGE_GATE_3_ACTION_LABEL) &&
          action.state !== WIRActionStatus.DELETED,
      ),
    );

  // Always add 'finalWirSignOff' as the last section
  const finalWirSignOffSection = {
    label: WIRStageGate3Sections['finalWirSignOff'],
    value: 'finalWirSignOff',
    phase: WIRCreateJourneyStepsKeys.STAGE_GATE_3,
  };

  return [...defaultSections, ...checklistSections, finalWirSignOffSection];
};
